<template>
  <div class="bg-title-container">
    <div class="bg-title-text">{{ props.titleData.title }}</div>
    <div class="bg-title-btn" @click="toStudy(props.titleData.url)">立即学习</div>
  </div>
  <div class="zhima-series-title">{{ props.title }}</div>
  <div class="zhima-series-cards">
    <img src="@/assets/images/home/left-arrow.png" alt="" class="left-arrow arrow" @click="handleClickLeft"/>
    <div class="card" v-for="item in displayList" :key="item.id" @click="toPage('/zms?id=' + item.id)">
      <div class="card-img">
        <img :src="item.firstImg" class="video-group-firstimg" alt="card-img" />
      </div>
      <div class="card-content">
        <div class="card-title">{{ item.name }}</div>
        <div class="card-title card-title2">{{ item.intro }}</div>
        <div class="card-text">{{ item.intro }}</div>
      </div>
      <!-- TODO 需要判断是否已经购买或者视频是否为免费视频 -->
      <div class="unbuy" v-if="!userVideoGroupTypeList.includes(item.type) && !isBuy && item.free == 'no'">
        <el-icon size="48"><Lock /></el-icon>
        <div class="title3">会员专享</div>
        <div class="title4">请购买智码单会员或升级联合会员后学习</div>
        <div class="btn-buy" @click="toBuy">前去购买</div>
      </div>
    </div>
    <img src="@/assets/images/home/right-arrow.png" alt="" class="right-arrow arrow" @click="handleClickRight">
  </div>
</template>

<script setup>
import { getUserInfo } from '@/utils/common'
import { jumpBlankUrl } from '@/utils/jump'
import { ref, defineProps, onMounted, watch } from 'vue'

const isBuy = ref(false)
const userVideoGroupTypeList = ref([])

//获取缓存用户细腻
const userInfo = getUserInfo()

const props = defineProps({
  titleData: {
    type: Object
  },
  title: {
    type: String,
    default: ''
  },
  list: {
    type: Array,
    default: () => []
  },
})

const toPage = (uri) => {
  window.open(uri, '_blank')
}

const toStudy = (url) => {
  // TODO 跳转
  console.log("立即学习", props.studyUrl)
  if(url){
    if(url.startsWith('http')){
      jumpBlankUrl(url)
    }else{
      window.open(url, '_blank')
    }
    
  }
}


const displayList = ref([])

const curIndex = ref(0)

const handleClickLeft = () => {
  curIndex.value -= 3
  if (curIndex.value < 0) {
    curIndex.value = props.list.length - 3
  }
  updateDisplayList()
}
const handleClickRight = () => {
  curIndex.value += 3
  if (curIndex.value > props.list.length - 3) {
    curIndex.value = 0
  }
  updateDisplayList()
}

// 更新 displayList 的方法
const updateDisplayList = () => {
  displayList.value = props.list.slice(curIndex.value, curIndex.value + 3)
};

watch([() => props.list, () => props.currentPage, () => props.pageSize], updateDisplayList, { immediate: true });

//初始化页面数据
const initPageData = () => {
  if (props.list && props.list.length > 0) {
    updateDisplayList()
  }
  //检查会员权限
  checkUserVipStatus();

}

//判断用户会员状态，并对isBuy赋值
const checkUserVipStatus = () => {
  userVideoGroupTypeList.value = userInfo?.videoGroupTypeList || [];
  //判断用户是否登录，用户是否信息存在,
  //判断用户是否是会员，如果是会员，则判断用户是否有权限
  if(userInfo?.vipLevel == 'all'){
    isBuy.value = true
    return
  }
  if(userInfo?.vipLevel == 'one' && userInfo?.vipPlatformCodeList){
    //如果是单会员，判断用户是否购买了本平台（智码）的会员
    if(userInfo?.vipPlatformCodeList?.includes('20250330111183747383')){
      isBuy.value = true
      return
    }
  }
}

onMounted(() => {
  initPageData();
})
</script>

<style scoped>
.bg-title-container {
  width: 1440px;
  height: 350px;
  background: url('@/assets/images/score-imgs/score-img-first.png') no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.bg-title-text {
  font-size: 40px;
  font-weight: 700;
  color: #000;
}
.bg-title-btn {
  width: 246px;
  height: 60px;
  color: #fff;
  background-color: #de1818;
  border-radius: 34px;
  position: absolute;
  bottom: 20px;
  left: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 34px;
  font-weight: 700;
  cursor: pointer;
}
.zhima-series-title {
  font-size: 48px;
  font-weight: 700;
  color: #000;
  text-align: left;
  padding: 20px 0;
}
.zhima-series-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4vw;
  width: 1440px;
  position: relative;
}
.card {
  /* width: 440px; */
  height: 524px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dfdfdf;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}
.card-title {
  font-size: 32px;
  font-weight: 700;
  color: #000;
  text-align: left;
}
.card-content {
  background-color: antiquewhite;
  flex: 1;
  padding: 20px;
  text-align: left;
}
.card-text {
  color: #333;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}
.video-group-firstimg {
  width: 100%;
  height: 400px;
}
.unbuy {
  position: absolute;
  background-color: #000a;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  color: #fff;
}
.btn-buy {
  background-color: #336fff;
  color: #fff;
  width: 80px;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}
.arrow {
  width: 25px;
  height: 45px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.arrow.left-arrow {
  margin-right: 40px;
  margin-top: 6px;
  left: -40px;
}
.arrow.right-arrow {
  margin-left: 40px;
  margin-top: 6px;
  right: -40px;
}
</style>
